import { Greyscale, PrimaryColor } from 'glints-aries';
import styled from 'styled-components';

export const InputWrapper = styled.div`
  display: block;
  position: relative;
`;

export const InputName = styled.span`
  position: absolute;
  padding: 1em;
  color: ${Greyscale.grey};
  transition:
    font-size 200ms,
    padding 200ms;
  z-index: 1;
  pointer-events: none;
  font-weight: 300;

  ${props => {
    if (props.floating) {
      return `
        margin-left: 1em;
        padding: 0px 2px;
        background-color: ${Greyscale.white};
        font-size: 10px;
        color: ${Greyscale.black};
        top: -1em;
`;
    }
  }}
`;

export const InputTypeWrapper = styled.div`
  position: relative;
  display: flex;
  margin-bottom: 5px;
`;

export const InputType = styled.input`
  font-size: 14px;
  color: #656565;
  outline: none;
  width: 100%;
  padding: 1em;
  border: ${props => {
    if (!props.valid) {
      return `2px solid ${PrimaryColor.glintsred}`;
    } else if (props.floating) {
      return `2px solid ${Greyscale.black}`;
    } else {
      return `1px solid ${Greyscale.lightgrey}`;
    }
  }};
`;

export const ErrorMessage = styled.span`
  color: ${PrimaryColor.glintsred};
`;

export const ValidationIconContainer = styled.div`
  position: absolute;
  right: ${({ shouldShiftLeft }) => (shouldShiftLeft ? '30px' : '10px')};
  display: flex;
  align-items: center;
  height: 100%;
`;
